export enum InvoiceEditorVariant {
  CreditNoteFromInvoice = 'credit_note.from_invoice',
  DepositInvoiceDraftEdit = 'invoice.deposit.draft.edit',
  DepositInvoiceNewFromQuote = 'invoice.deposit.new_from_quote',
  FinalInvoiceDraftEdit = 'invoice.final.draft.edit',
  FinalInvoiceNewFromQuote = 'invoice.final.new_from_quote',
  InvoiceDraftDuplicate = 'invoice.draft.duplicate',
  InvoiceDraftEdit = 'invoice.draft.edit',
  InvoiceDuplicate = 'invoice.duplicate',
  InvoiceNew = 'invoice.new',
  InvoiceNewFromQuote = 'invoice.new_from_quote',
  QuoteDraftDuplicate = 'quote.draft.duplicate',
  QuoteDraftEdit = 'quote.draft.edit',
  QuoteDuplicate = 'quote.duplicate',
  QuoteEdit = 'quote.edit',
  QuoteNew = 'quote.new',
  RecurringInvoiceDraftEdit = 'recurring_invoice.draft.edit',
  RecurringInvoiceDuplicate = 'recurring_invoice.duplicate',
  RecurringInvoiceEdit = 'recurring_invoice.edit',
  RecurringInvoiceNew = 'recurring_invoice.new',
}
